import { redirectToLogin } from 'utils/login';

import { SHOPPING_LISTS_SHOW_MODAL } from 'redux/modules/shopping-lists/actions/types';
import { isUserLoggedIn } from 'redux/modules/sessions/selectors';

export const showListsModal = lineNumber => (dispatch, getState) => {
  if (!isUserLoggedIn(getState())) {
    return redirectToLogin();
  }

  return dispatch({
    type: SHOPPING_LISTS_SHOW_MODAL,
    payload: lineNumber,
  });
};
